<template>
  <Slide class="main-menu" :closeOnNavigation="true" ref="burgerMenu" noOverlay right>
    <div class="menu">
      <ul class="menu-list columns is-multiline is-gapless" style="min-width: 50%">
        <li class="column is-half">
          <router-link :to="{name: 'Home'}">Home</router-link>
        </li>
        <li class="column is-half">
          <router-link :to="{name: 'About'}">About</router-link>
        </li>
        <li class="column is-half">
          <router-link :to="{name: 'FAQs'}">FAQs</router-link>
        </li>
        <li class="column is-half">
          <router-link :to="{name: 'Credits'}">Credits</router-link>
        </li>
      </ul>
    </div>
    <div class="menu" style="width: 270px; flex: 1; min-height: 0;">
      <unlocking-contents v-bind:currentPage="currentPage" />
    </div>
    <div class="menu columns is-mobile is-gapless flex-end">
    <ul class="menu-list column is-half">
      <li class="">
        <a href="#" v-if="$store.state.user" @click="logout">Logout</a>
        <router-link :to="{name: 'Login'}" v-if="!$store.state.user">Login</router-link>
      </li>
    </ul></div>
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import { logout } from '@/firebaseService'
import UnlockingContents from '@/components/UnlockingContents.vue'
export default {

  name: 'Menu',

  data () {
    return {
      currentPage: this.$route.name,
      open: false
    }
  },
  methods: {
    logout
  },
  components: {
    Slide,
    UnlockingContents
  },
  props: {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="css" scoped>
.menu{
  text-align: left;
}
.flex-end{
  justify-content: flex-end;
  text-align: right;
}
</style>
